// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import es6Promise from 'es6-promise'
import 'babel-polyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import naver from 'vue-naver-maps'
import * as VueGoogleMaps from 'vue2-google-maps'

es6Promise.polyfill()
Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(naver, {
  clientID: 'Q3terhW342KFsdfC1M',
  useOpenAPI: true
})
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDFkxJtg8Ig0EAgpjqRjHEYn0XEPs-b_Po',
    libraries: 'places'
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js